import PropTypes from "prop-types";

import { CollegeMajorsCard as CommonCollegeMajorsCard } from "../../../../../core/compose/cards";

function CollegeMajorsCard({
  open,
  chosenSchool,
  externalToggle,
  callbackToggle,
}) {
  return (
    <CommonCollegeMajorsCard
      open={open}
      chosenSchool={chosenSchool}
      externalToggle={externalToggle}
      callbackToggle={callbackToggle}
    />
  );
}

CollegeMajorsCard.propTypes = {
  open: PropTypes.bool,
  externalToggle: PropTypes.bool,
  callbackToggle: PropTypes.func,
  chosenSchool: PropTypes.shape(),
};

export default CollegeMajorsCard;
